<template>
    <!--个人中心-->
  <div id="personcenter">
    <h2 class="title">
      <a @click="back" class="prev"></a>
    </h2>
    <div class="head">
      <dl>
        <dt>
          <img :src="UserInfo[0].val ? UserInfo[0].val : require('../../assets/img/personnote_img_avatar1.png')" alt="">
        </dt>
        <dd>
          {{UserInfo[1].val}}
        </dd>
      </dl>
    </div>
    <div class="main">
      <a :href="item.href" v-for="(item, index) in UserInfo" :key="index" v-if="index > 1">
        <span><img :src="item.img" alt="">{{item.name}} : {{item.val}}</span>
        <i href="" style="display: none">></i>
      </a>
    </div>
    <a @click="logout()" class="logout">退出登录</a>
    <div style="display: none">
      name：{{this.$store.state.name}}<br>
      nickname：{{this.$store.state.nickname}}<br>
      period：{{this.$store.state.period}}<br>
      portrait：{{this.$store.state.portrait}}<br>
      school：{{this.$store.state.school}}<br>
      subject：{{this.$store.state.subject}}<br>
      token：{{this.$store.state.token}}<br>
      uid：{{this.$store.state.uid}}<br>
      vipname：{{this.$store.state.vipname}}<br>
      viptime：{{this.$store.state.viptime}}<br>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonCenter',
  data () {
    return {
      UserInfo: {}
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('alterName', '')
      this.$store.dispatch('alterNickname', '')
      this.$store.dispatch('alterPeriod', '')
      this.$store.dispatch('alterPortrait', '')
      this.$store.dispatch('alterSchool', '')
      this.$store.dispatch('alterSubject', '')
      this.$store.dispatch('alterToken', '')
      this.$store.dispatch('alterUid', '')
      this.$store.dispatch('alterVipname', '')
      this.$store.dispatch('alterViptime', '')
      console.log(this.$store.state.name)
      console.log(this.$store.state.nickname)
      console.log(this.$store.state.period)
      console.log(this.$store.state.portrait)
      console.log(this.$store.state.school)
      console.log(this.$store.state.subject)
      console.log(this.$store.state.token)
      console.log(this.$store.state.uid)
      console.log(this.$store.state.vipname)
      console.log(this.$store.state.viptime)
      alert('退出成功')
      this.back()
    },
    getUserInfo () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_user_data',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.UserInfo = res.data.data
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    back () {
      if (window.history.length <= 1) {
        this.router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  },
  mounted () {
    this.getUserInfo()
  }
}
</script>

<style scoped lang="stylus">
#personcenter
  .title
    position: relative
    height: 1.08rem
    line-height: .8rem
    background-color: #1E81F2
    padding: .14rem .16rem
    font-size: .32rem
    color: #fff
    font-weight: 600
    text-align: center
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    a.prev
      position: absolute
      top: .14rem
      left: .16rem
      display: block
      width: .8rem
      height: .8rem
      background-color: transparent
      -webkit-border-radius: 50%
      -moz-border-radius: 50%
      border-radius: 50%
      &::before
        content: ""
        position: absolute
        top: .3rem
        left: .32rem
        display: block
        width: .20rem
        height: .20rem
        border-left: .03rem solid #fff
        border-bottom: .03rem solid #fff
        -webkit-transform: rotate(45deg)
        -moz-transform: rotate(45deg)
        -ms-transform: rotate(45deg)
        -o-transform: rotate(45deg)
        transform: rotate(45deg)
  .head
    overflow: hidden
    padding: 0 0 .4rem
    background-color: #1E81F2
    background: url(../../assets/img/personcenter_img_bg1.png) no-repeat center -1.44rem
    -webkit-background-size: 7.5rem 3.22rem
    background-size: 7.5rem 3.22rem
    dl
      width: 2.4rem
      margin: .1rem 0 0 1.54rem
      dt
        width: 1.6rem
        height: 1.6rem
        margin: 0 auto
        img
          width: 100%
          height: 100%
      dd
        width: 2.4rem
        height: .5rem
        margin-top: .2rem
        font-size: .36rem
        color: #050505
        text-align: center
  .main
    padding: 0 .4rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    a
      display: flex
      justify-content: space-between
      align-items: center
      margin: .48rem 0
      span
        display: block
        height: .46rem
        line-height: .46rem
        font-size: .28rem
        color: #333
        img
          vertical-align: middle
          width: .38rem
          height: .46rem
          margin-right: .2rem
  a.logout
    position: fixed
    bottom: .82rem
    left: 50%
    display: block
    width: 6.7rem
    height: .8rem
    line-height: .8rem
    background-color: #1E81F2
    font-size: .32rem
    color: #fff
    text-align: center
    -webkit-border-radius: .4rem
    -moz-border-radius: .4rem
    border-radius: .4rem
    -webkit-transform: translate(-50%, 0)
    -moz-transform: translate(-50%, 0)
    -ms-transform: translate(-50%, 0)
    -o-transform: translate(-50%, 0)
    transform: translate(-50%, 0)
</style>



// WEBPACK FOOTER //
// src/components/personal/PersonCenter.vue